import React, { useEffect, useState } from 'react'
import styles from "../MetaField.module.scss"
import { CustomDropdown } from 'components/shared/customDropdown'
import { TextField } from '@mui/material'
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { AssignToFilterContainer } from 'components/pages/tasks/components/AssignToFilterContainer'
import { useDispatch, useSelector } from 'react-redux';
import { setDroppedItems } from 'redux/slices/triggerSlice';
import { setPublish } from 'redux/slices/globalSlice';
const options = [
    {
        label: "today", value: "today"
    },
    {
        label: "yesterday", value: "yesterday"
    },
    {
        label: "this week (Mon-today)", value: "this week (mon-today)"
    },
    {
        label: "last week", value: "last week"
    },
    {
        label: "this month(1st- today)", value: "this month(1st- today)"
    },
    {
        label: "last month", value: "last month"
    },
    {
        label: "previous", value: "previous"
    },
    {
        label: "is after date", value: "is after date"
    },
    {
        label: "is before date", value: "is before date"
    },
    {
        label: "between", value: "between"
    }

]
const optionsDate = Array.from({ length: 30 }, (_, i) => ({
    label: `${i + 1}`,
    value: `${i + 1}`,
}));
const optionsTimeUnits = [
    { label: "Days", value: "Days" },
    { label: "Weeks", value: "Weeks" },
    { label: "Months", value: "Months" },
    { label: "Years", value: "Years" },
];
const DateSubmitted = ({
    item
}) => {
    const { triggerDroppedList } = useSelector((state) => state?.trigger)
    const dispatch = useDispatch()
    const [localOptions, setLocalOptions] = useState(item?.trigger || { label: "Date Submitted", options: item?.operator || "today", value: item?.value || "", startdate: item?.value?.[0], enddate: item?.value?.[1], date: item?.value?.[0], days: item?.value?.[1] });

    const handleDelete = () => {
        const filteredDroppedItems = triggerDroppedList?.filter((e) => e?.id !== item?.id)
        dispatch(setDroppedItems(filteredDroppedItems))
        dispatch(setPublish(true))
    }
    const handleChange = (name, value) => {
        setLocalOptions((prev) => {
            let updatedOptions = { ...prev, [name]: value };

            if (name === "options") {
                updatedOptions = {
                    ...updatedOptions,
                    value: "",
                    enddate: "",
                    startdate: "",
                };
            }

            return updatedOptions;
        });
    };
    useEffect(() => {
        const updatedTriggerList = triggerDroppedList?.map((e) => {
            if (e?.id === item?.id) {
                return {
                    ...e,
                    trigger: { ...localOptions },
                };
            }
            return e;
        });
        dispatch(setDroppedItems(updatedTriggerList));
    }, [localOptions]);

    useEffect(() => {
        setLocalOptions((prev) => ({
            ...prev,
            options: item?.operator || prev.options,
            ...(item?.value?.[0] ? {
                date: item?.value?.[0]
            } : {}),
            ...(item?.value?.[1] ? {
                days: item?.value?.[1]
            } : {}),
            ...(item?.value?.[0] ? {
                startdate: item?.value?.[0]
            } : {}),
            ...(item?.value?.[1] ? {
                enddate: item?.value?.[1]
            } : {}),

            ...(item?.value ? {
                value: item?.value
            } : {}),
        }));
    }, [item?.operator, item?.value]);
    return (
        <>
            <div className={styles?.metaContainer}>
                <div className={styles?.field}>
                    <TextField value={"Date Submitted"} disabled={true} />
                    <CustomDropdown options={options} width='200px' onChange={(e) => {
                        handleChange(e?.target?.name, e?.target.value)
                    }} name="options" value={localOptions?.options} />
                    {
                        localOptions?.options == "previous" ?
                            <>
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px"
                                }}>
                                    <CustomDropdown
                                        name="date"
                                        value={localOptions?.date}
                                        options={optionsDate}
                                        onChange={(e) => {
                                            handleChange(e?.target?.name, e?.target.value)
                                        }}
                                    />
                                    <CustomDropdown
                                        name="days"
                                        value={localOptions?.days}
                                        options={optionsTimeUnits}
                                        onChange={(e) => {
                                            handleChange(e?.target?.name, e?.target.value)
                                        }}
                                    />
                                    <span style={{ fontWeight: "700", fontSize: "15px" }}>ago</span>
                                </div>
                            </>


                            :

                            localOptions?.options == "is after date" || localOptions?.options == "is before date" ?
                                <TextField
                                    inputProps={{
                                        style: { width: "170px" },
                                    }}
                                    name="value"
                                    value={localOptions?.value}
                                    type='date'
                                    onChange={(e) => {
                                        handleChange(e?.target?.name, e?.target.value)
                                    }}
                                /> :

                                localOptions?.options == "between" ?
                                    <>
                                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                            <TextField
                                                name="startdate"
                                                value={localOptions?.startdate}
                                                type='date'
                                                onChange={(e) => {
                                                    handleChange(e?.target?.name, e?.target.value)
                                                }}
                                            />
                                            <span style={{ fontWeight: "700" }}>And</span>
                                            <TextField
                                                name="enddate"
                                                value={localOptions?.enddate}
                                                type='date'
                                                onChange={(e) => {
                                                    handleChange(e?.target?.name, e?.target.value)
                                                }}
                                            />
                                        </div>
                                    </>
                                    :
                                    null

                    }
                </div>


                <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }} onClick={handleDelete}>
                    <HighlightOffIcon />
                </div>



            </div>
        </>
    )
}

export default DateSubmitted;